/** @format */

export default {
  onTableData(o: any, resData: any) {
    const totals = resData.total;

    if (totals != null) {
      o.push({
        totalAmount: totals.totalAmount, //应收
        paidAmount: totals.paidAmount, //实收
        discountAmount: totals.discountAmount, //优惠金额
        unpaidAmount: totals.unpaidAmount, //应收未收
        specialAmount: totals.specialAmount, //减免金额
        pkOrderId: Symbol().toString(),
        // parkName: '合计',
        isTotalRow: true
      });

      // this.pageSize = this.defaultPageSize - 0 + 1
    }

    // console.log('on table data invoked', resData)
    return o;
  },
  onDetail(o: any) {
    function getImgRenderFunInDetailDialog(basicInfo, prop = 'img') {
      const imgNode = basicInfo.fields.find((item: { prop: string }) => item.prop === prop);
      if (!imgNode) {
        console.log('木有图片节点111');
        return false;
      }
      imgNode.render = (
        c: (
          arg0: string,
          arg1: { attrs: { src: any }; on: { click: () => void }; style: { 'max-width': string } }
        ) => any
      ) => {
        return c('img', {
          attrs: {
            src: this.$API_SERVER.imgBaseUrl + basicInfo.data[imgNode.prop]
          },
          on: {
            // @ts-ignore
            click: $e => {
              // this.$message.info('请允许新窗口打开以查看图片')
              // window.open($e.target.src)
              // console.log('$e---:', $e)
              this.reviewImages(basicInfo.data, prop);
            },
            error: e => {
              e.target.setAttribute('src', this.$API_SERVER.defaultImg);
            }
          },
          style: {
            // 'max-width': '50%',
            // @ts-ignore
            'max-height': '100px'
          }
        });
      };
    }

    this.reviewDescriptionOfDialog = '';
    console.log('this.detailDialogType---', this.detailDialogType);
    const basicInfo = o['基本信息'];
    // debugger
    const self = this;
    const tempFields = basicInfo.fields;
    basicInfo.fields = []

      .concat([
        {
          label: '入场图片',
          prop: 'enterImg'
        },
        {
          label: '出场图片',
          prop: 'exitImg'
        }
      ])
      .concat(
        tempFields.filter(
          (item: { label: string }) =>
            !item.label.startsWith('审核') && !(item.label.includes('收') || item.label.includes('金额'))
        )
      );

    let reviewInfo;

    if ('DETAIL' == this.detailDialogType) {
      reviewInfo = {
        fields: tempFields.filter((item: { label: string }) => item.label.startsWith('审核')),
        data: basicInfo.data
      };
    }

    if ('REVIEW' == this.detailDialogType) {
      reviewInfo = {
        fields: [
          {
            label: '审核意见',
            render(
              c: (
                arg0: string,
                arg1: {
                  attrs: { placeholder: string };
                  style: { 'max-width': string; width: string };
                  on: { change(e: any): void };
                },
                arg2: string
              ) => any
            ) {
              return c(
                'a-textarea',
                {
                  attrs: {
                    placeholder: '请输入审核意见'
                  },
                  style: {
                    'max-width': '250%',
                    width: '250%'
                  },
                  on: {
                    change(e) {
                      self.reviewDescriptionOfDialog = e.target.value;
                      console.log('this is on change--:', e.target.value);
                    }
                  }
                },
                ''
              );
            }
          }
        ],
        data: basicInfo.data
      };
    }
    console.log('basicInfo--:', basicInfo);

    getImgRenderFunInDetailDialog.call(self, basicInfo, 'exitImg');
    getImgRenderFunInDetailDialog.call(self, basicInfo, 'enterImg');

    return {
      ...o,

      收费信息: {
        data: basicInfo.data,
        fields: tempFields.filter(
          (item: { label: string | string[] }) => item.label.includes('收') || item.label.includes('金额')
        )
      },
      审核信息: reviewInfo
    };
  },
  onSearch(o: any) {
    return {
      parkIds: o.parkIds instanceof Array ? o.parkIds.join(',') : o.parkIds,
      currPage: this.current,
      // plate: o.adapterDataForViewModel.plateHead + o.adapterDataForViewModel.plateTail,
      // userId: '',
      pageSize: this.pageSize,
      source: o.source instanceof Array ? o.source.join(',') : o.source,
      channelIds: o.channelIds instanceof Array ? o.channelIds.join(',') : o.channelIds,
      cancelAmout: String(o.cancelAmout),
      unpaidAmout: String(o.unpaidAmout)
    };
  }
};
